import { render } from "./TeamBudgetView.vue?vue&type=template&id=de448200"
import script from "./TeamBudgetView.vue?vue&type=script&lang=js"
export * from "./TeamBudgetView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__